import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-seo-landing',
  templateUrl: './seo-landing.component.html',
  styleUrls: ['./seo-landing.component.scss'],
})
export class SeoLandingComponent {
  readonly slug: string;
  private readonly sections: Set<string>;

  constructor(
    route: ActivatedRoute,
    private readonly transloco: TranslocoService,
  ) {
    const data = route.snapshot.data;
    this.slug = data['slug'] ?? '';
    this.sections = new Set(data['sections'] ?? []);
  }

  /** Transloco treats "" as a missing key and returns the key path. */
  copy(field: 'title' | 'description' | 'h1'): string {
    const key = `seo.landing.${this.slug}.${field}`;
    const value = this.transloco.translate(key);
    if (!value || value === key) {
      return '';
    }
    return value;
  }

  has(section: string): boolean {
    return this.sections.has(section);
  }
}
